import {Component,} from '@angular/core';
import {OneToManyComponent} from "../../one-to-many.component";
import {Campanha} from "../../../../domain/Campanha";
import {CameraSource} from "@capacitor/camera";

@Component({
  selector: 'app-campanha',
  templateUrl: './edit-campanhas.component.html',
  styleUrls: ['./edit-campanhas.component.scss'],
})
export class EditCampanhasComponent extends OneToManyComponent<Campanha>  {
  override newObject(): Campanha {
    const cap = new Campanha();
    cap.agencia_sigla = localStorage.getItem("agencia")!!
    return cap
  }

}
